// Serviço do domínio clinics — contextos de origem dos pacientes.
import { createClient } from '@/lib/supabase/client'
import type { Clinica, TipoClinica } from '@/lib/types'
import { registrarAuditoria } from '@/services/identity'

export async function listClinicas(workspaceId: string): Promise<Clinica[]> {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('clinicas')
    .select('id, workspace_id, nome, tipo, cor, ativo')
    .eq('workspace_id', workspaceId)
    .is('deleted_at', null)
    .order('nome')
  if (error) throw error
  return (data ?? []) as Clinica[]
}

export async function criarClinica(params: {
  workspaceId: string
  nome: string
  tipo: TipoClinica
  cor?: string | null
}): Promise<Clinica> {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('clinicas')
    .insert({
      workspace_id: params.workspaceId,
      nome: params.nome.trim(),
      tipo: params.tipo,
      cor: params.cor ?? null,
    })
    .select('id, workspace_id, nome, tipo, cor, ativo')
    .single()
  if (error) throw error
  await registrarAuditoria({
    workspaceId: params.workspaceId,
    acao: 'clinica_criada',
    entidade: 'clinicas',
    registroId: (data as Clinica).id,
  })
  return data as Clinica
}

export async function atualizarClinica(params: {
  workspaceId: string
  id: string
  nome?: string
  tipo?: TipoClinica
  cor?: string | null
  ativo?: boolean
}): Promise<void> {
  const supabase = createClient()
  const patch: Record<string, unknown> = {}
  if (params.nome !== undefined) patch.nome = params.nome.trim()
  if (params.tipo !== undefined) patch.tipo = params.tipo
  if (params.cor !== undefined) patch.cor = params.cor
  if (params.ativo !== undefined) patch.ativo = params.ativo
  const { error } = await supabase
    .from('clinicas')
    .update(patch)
    .eq('id', params.id)
    .eq('workspace_id', params.workspaceId)
  if (error) throw error
  await registrarAuditoria({
    workspaceId: params.workspaceId,
    acao: 'clinica_atualizada',
    entidade: 'clinicas',
    registroId: params.id,
    dados: patch,
  })
}
